import React from "react";
import PasswordIcon from "@mui/icons-material/Password";

function GddPasswordIcon({ iconColor, iconSize = "small", ...other }) {
    return <PasswordIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default GddPasswordIcon;
